(function () {'use strict';}());
angular.module("app").directive('slidingScale', function($document,$timeout) {
    return {
      restrict: 'A',
      templateUrl: 'views/sliding-scale.html?version=1.0',
      scope: {model:"="},

      link:function($scope,element,attr)
      {
        var trace = angular.trace;

        $scope.getLabel = function(value){
        	if(value === null) return "select an option";
        	return element.find("li").eq(parseInt(value)).find("label").text();
        };

        $scope.increment = function(){
        	var value = parseInt($scope.model.userResponse);
        	if(value === 4) return;
        	if(isNaN(value)) $scope.model.userResponse = "0";
        	else $scope.model.userResponse = (value + 1).toString();
        };
        $scope.decrement = function(){
        	var value = parseInt($scope.model.userResponse);
        	if(value === 0) return;
        	if(isNaN(value)) $scope.model.userResponse = "0";
        	else $scope.model.userResponse = (value - 1).toString();
        };
      }  
    };
  });